module.exports = __webpack_public_path__ + "img/push_notifications.94eeb7f3.png";